var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailsIconHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.033,
    height: 23.033,
    viewBox: "0 0 23.033 23.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_4b46831afe071bc28700e888afb5b132",
    "data-name": "4b46831afe071bc28700e888afb5b132",
    d: "M13.022,1A11.516,11.516,0,1,0,24.539,12.516,11.529,11.529,0,0,0,13.022,1Zm0,1.645a9.871,9.871,0,1,1-9.871,9.871A9.858,9.858,0,0,1,13.022,2.645ZM12.2,5.936V7.581h1.645V5.936Zm0,3.29V19.1h1.645V9.226Z",
    transform: "translate(-1.506 -1)",
    fill: "#00aeef"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIconHover);
export default __webpack_public_path__ + "static/media/detailsIconHover.270b6e6a961e9082d974f3d601fe7ce4.svg";
export { ForwardRef as ReactComponent };